import {MessageBox} from "element-ui";
import Router from '@/router';


export const handleSendFirstNewBike = (user, userIsReady, userHasBankAccount) => {

   if (!userIsReady) {
      MessageBox.confirm(`${user.firstName}, para você adicionar a sua primeira bike, você precisa antes completar o seu perfil. Esse procedimento é necessário para garantir a qualidade dos nossos serviços.`, 'Warning', {
         title: "Complete seu perfil!",
         confirmButtonText: 'OK, quero completar o meu perfil',
         showCancelButton: false,
         closeOnClickModal: false,
         showClose: false
      }).then(() => {
         Router.push({name: 'profile'})
      }).catch(() => {

      });
      return false
   }

   if (!userHasBankAccount) {
      MessageBox.confirm(`${user.firstName}, antes prosseguir, precisamos que você cadastre uma Conta Bancária em seu nome, um Documento pessoal (RG ou CNH) e a comprovação deste documento via selfie com o documento ao lado do rosto. Esse procedimento garante a qualidade e a segurança dos serviços Pedale.`, 'Warning', {
         title: "Cadastre uma conta bancária!",
         confirmButtonText: 'OK, realizar cadastro',
         showCancelButton: false,
         closeOnClickModal: false,
         showClose: false
      }).then(() => {
         Router.push({name: 'finalize-register'})
      }).catch(() => {

      });
      return false
   }

   /* if (!userHasDocs) {
      MessageBox.confirm(`${user.firstName}, você ainda não enviou os seus documentos para comprovar a sua legitimidade. Por favor, envie agora mesmo!`, 'Warning', {
         title: "Envio os documentos!",
         confirmButtonText: 'OK, enviar documentos',
         showCancelButton: false,
         closeOnClickModal: false,
         showClose: false
      }).then(() => {
         Router.push({name: 'finalize-register'})
      }).catch(() => {

      });
      return false
   } */

   /* if (!approvedDigitalAccount) {
      MessageBox.confirm(`${user.firstName}, para a sua segurança, estamos validando os dados que você nos forneceu. Aguarde até que nossa equipe aprove o seu cadastro.`, 'Warning', {
         title: "Estamos verificando seus dados.",
         confirmButtonText: 'OK, obrigado(a)',
         showCancelButton: false,
         closeOnClickModal: false,
         showClose: false
      }).then(() => {
         Router.push({name: 'dashboard'})
      }).catch(() => {

      });
      return false
   } */

   Router.push('/painel/nova-bicicleta')

}
